export default "__VITE_ASSET__D9xZird1__"